import styled from 'styled-components';

import { Dropdown as DefaultDropdown } from '@xing-com/text-field';
import { scale005, scale010, scale100, scale110 } from '@xing-com/tokens';

const customBackgroundLight = '#FFFFFF';
const customBackgroundDark = '#161C24';

const customBorderLight = '#BCC9D1';
const customBorderDark = '#616D7D';

const customIconLight = '#1D2124';
const customIconDark = '#FFFFFF';

const customDropdownWidth = '481px';
const customDropdownHeight = '48px';

export const Dropdown = styled(DefaultDropdown)`
  max-width: ${customDropdownWidth};
  height: ${customDropdownHeight};
  & select {
    padding: 0px 0px 0px ${scale100};
    gap: 0px;
    border-radius: ${scale110};
    border-width: ${scale005};
    justify: space-between;

    // Override of the default styles

    opacity: 0px;

    background-color: ${customBackgroundLight};
    border-color: ${customBorderLight};
    &:focus {
      background-color: ${customBackgroundLight} !important;
      border: ${scale010} solid ${customBorderLight} !important;
    }
    &:hover {
      border: ${scale010} solid ${customBorderLight};
    }
    @media (prefers-color-scheme: dark) {
      background-color: ${customBackgroundDark};
      border-color: ${customBorderDark};

      &:focus {
        background-color: ${customBackgroundDark} !important;
        border: ${scale010} solid ${customBorderDark} !important;
      }
      &:hover {
        border: ${scale010} solid ${customBorderDark};
      }
    }
  }
  & svg {
    color: ${customIconLight};
    @media (prefers-color-scheme: dark) {
      color: ${customIconDark};
    }
  }
`;
